<template>
  <div class="container-view">
    <!-- Header/Banner Section -->
    <section class="banner-section">
      <div class="banner-content">
        <header class="site-header">
          <div class="header-inner">
            <div class="brand">
              <img class="brand-logo" src="https://pic1.zhuanstatic.com/zhuanzh/bbb7041e-b0f7-4d40-8be5-0a80e55ab2b6.jpg" alt="无限进化传媒" />
              <span class="brand-name-cn">无限进化传媒</span>
              <span class="brand-name-en">INFINITE EVOLVE</span>
            </div>
            <nav class="main-nav">
              <a href="#about">关于我们</a>
              <a href="#vision">愿景</a>
              <a href="#services">业务矩阵</a>
              <a href="#contact" class="nav-cta">合作咨询</a>
            </nav>
          </div>
        </header>

        <div class="hero-inner">
          <p class="hero-kicker">成立于2025年·综合性MCN机构</p>
          <h1 class="hero-title">
            <span class="hero-title-line">
              <span class="hero-title-white">以</span><span class="hero-title-gradient">内容+广告</span>
            </span>
            <span class="hero-title-white">双驱动增长</span>
          </h1>
          <p class="hero-subtitle">
            全平台全品类签约百位优质创作者,深耕自孵科技数码与财经矩阵赛道
          </p>

          <div class="hero-actions">
            <a href="#about" class="hero-primary">了解更多 →</a>
            <a href="#contact" class="hero-secondary">联系我们</a>
          </div>
        </div>
        <div class="hero-scroll">
          <div class="scroll-indicator"></div>
        </div>
      </div>
    </section>

    <!-- About Section -->
    <section id="about" class="content-section">
      <div class="section-wrap">
        <div class="section-header">
          <h2 class="section-title">无限进化传媒介绍</h2>
          <p class="section-desc">
            无限进化传媒成立于2025年，是以内容+广告双驱动的综合性MCN机构，全平台全品类签约百位优质创作者，深耕自孵科技数码与财经矩阵赛道，深度服务3C、网服等全行业品牌客户，在达人营销品效合一的传播上实战成果丰富，致力于成为以优质内容驱动品牌增长的内容营销公司。
          </p>
        </div>
      </div>
    </section>

    <!-- Vision Section -->
    <section id="vision" class="content-section">
      <div class="section-wrap">
        <div class="section-header">
          <h2 class="section-title">愿景</h2>
          <p class="section-desc vision-text">用最深入人心的内容营销驱动无限增长</p>
        </div>
      </div>
    </section>

    <!-- Services Section -->
    <section id="services" class="content-section">
      <div class="section-wrap">
        <div class="section-header">
          <p class="section-kicker">SERVICE MATRIX</p>
          <h2 class="section-title">业务矩阵</h2>
          <p class="section-desc">
            围绕品牌的全链路增长需求，构建从内容生产、达人矩阵到投放优化的完整解决方案。
          </p>
        </div>

        <div class="service-grid">
          <div class="service-card">
            <h3>内容策略与创意</h3>
            <p>
              基于品牌阶段与人群洞察，制定差异化内容策略，打造具有传播力与记忆点的创意内容资产。
            </p>
          </div>
          <div class="service-card">
            <h3>自孵达人与矩阵运营</h3>
            <p>
              深耕科技数码与财经等垂类，构建多层级达人矩阵，通过长期陪伴式运营提升品牌心智占位。
            </p>
          </div>
          <div class="service-card">
            <h3>整合营销与投放</h3>
            <p>
              融合达人营销、信息流投放与站内外资源，为 3C、网服等行业制定可量化、可复盘的投放策略。
            </p>
          </div>
          <div class="service-card">
            <h3>数据洞察与效果优化</h3>
            <p>
              以数据为核心驱动，对投放过程进行实时监测与迭代优化，兼顾短期转化与长期品牌资产沉淀。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Cases Section -->
    <section id="cases" class="content-section">
      <div class="section-wrap">
        <div class="section-header">
          <p class="section-kicker">BRANDS & PLATFORMS</p>
          <h2 class="section-title">深度服务赛道</h2>
          <p class="section-desc">
            聚焦 3C、网服等高增长行业，基于不同平台生态提供长期、可复制的增长方案。
          </p>
        </div>

        <div class="cases-grid">
          <div class="cases-column">
            <h3>核心行业</h3>
            <ul>
              <li>3C 数码与智能硬件</li>
              <li>互联网服务与应用</li>
              <li>金融与财经内容生态</li>
              <li>新消费与生活方式品牌</li>
            </ul>
          </div>

          <div class="cases-column">
            <h3>平台布局</h3>
            <ul>
              <li>短视频与直播平台矩阵</li>
              <li>图文与社区内容平台</li>
              <li>资讯与财经垂直平台</li>
              <li>多端联动的全场景触达</li>
            </ul>
          </div>

          <div class="cases-column">
            <h3>合作方式</h3>
            <ul>
              <li>品牌整合年度合作</li>
              <li>新品发布与节点战役</li>
              <li>达人矩阵共建与运营</li>
              <li>效果导向的投放优化服务</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section id="contact" class="content-section">
      <div class="section-wrap">
        <div class="section-header">
          <p class="section-kicker">CONTACT</p>
          <h2 class="section-title">联系方式</h2>
          <p class="section-desc">
            如需商务合作、达人签约、平台对接或岗位招聘，欢迎通过以下方式与我们联系。
          </p>
        </div>

        <div class="contact-layout">
          <div class="contact-block">
            <h3>公司信息</h3>
            <p class="contact-address">
              深圳市无限进化文化传播有限公司
              <br />
              深圳市福田区莲花街道景华社区莲花路 2005 号文博大厦 3501
            </p>
            <p class="contact-note">
              我们期待与志同道合的品牌与创作者一起，用内容驱动长期、可持续的无限增长。
            </p>
          </div>

          <div class="contact-block contact-grid">
            <div class="contact-item">
              <h4>商务合作</h4>
              <p>邮箱：18681450582@163.com</p>
            </div>
            <div class="contact-item">
              <h4>达人合作</h4>
              <p>邮箱：16620948163@163.com</p>
            </div>
            <div class="contact-item">
              <h4>平台合作</h4>
              <p>邮箱：16675166872@163.com</p>
            </div>
            <div class="contact-item">
              <h4>岗位招聘</h4>
              <p>邮箱：16675140250@163.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="site-footer">
      <div class="footer-inner">
        <span>© 2025 深圳市无限进化文化传播有限公司</span>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          粤ICP备2026007014号
        </a>
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { url } from '@zz-common/zz-utils'

let lang = url.getParam('lang') || ''

export default Vue.extend({
  name: 'container-view',
  created() {
    // lang如果是en，就设置为en，其它情况设置为zh-cn
    lang = lang.includes('en') ? 'en' : 'zh-cn'
    this.$store.commit('switchLang', lang)

    // 如果页面分辨率大于1280，则给html设置overflow-x: hidden
    if (window.innerWidth > 1200) {
      document.documentElement.style.overflowX = 'hidden'
    }

    document.title = '无限进化传媒'
  }
})
</script>

<style scoped lang="scss">
.container-view {
  position: relative;
  width: 100%;
  min-width: 1280px;
  background: #fff;
  overflow-x: hidden;
}

.banner-section {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #000;
  color: #fff;
  overflow: hidden;
}

.banner-content {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.site-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  backdrop-filter: blur(20px);
  background-color: rgba(0, 0, 0, 0.7);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-inner {
  width: 100%;
  max-width: 1920px;
  padding: 16px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.brand {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.brand-logo {
  display: inline-block;
  height: 32px;
  width: auto;
  margin-right: 12px;
  vertical-align: middle;
  object-fit: contain;
}

.brand-name-cn {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.04em;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.brand-name-en {
  display: none;
}

.main-nav {
  display: flex;
  align-items: center;
  gap: 32px;
  font-size: 14px;
  flex-shrink: 0;
}

.main-nav a {
  color: #fff;
  text-decoration: none;
  transition: color 0.2s ease;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.main-nav a:hover {
  color: #60a5fa;
}

.nav-cta {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: #fff !important;
  padding: 8px 20px;
  border-radius: 6px;
  font-weight: 500;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.nav-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  color: #fff !important;
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.hero-kicker {
  font-size: 18px;
  letter-spacing: 0.1em;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 32px;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.hero-title {
  font-size: 80px;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: alibaba, 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.hero-title-line {
  display: inline-block;
}

.hero-title-gradient {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-title-white {
  color: #fff;
}

.hero-subtitle {
  max-width: 900px;
  margin: 0 auto 56px;
  font-size: 22px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.hero-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.hero-primary,
.hero-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px 40px;
  font-size: 18px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.hero-primary {
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: #fff;
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.4);
}

.hero-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 30px rgba(59, 130, 246, 0.6);
}

.hero-secondary {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.hero-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

.hero-scroll {
  position: absolute;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.scroll-indicator {
  width: 24px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  position: relative;
}

.scroll-indicator::before {
  content: '';
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 8px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 2px;
  animation: scrollDown 2s ease-in-out infinite;
}

@keyframes scrollDown {
  0% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(16px);
  }
}

.content-section {
  position: relative;
  width: 100%;
  min-width: 1280px;
  max-width: 1920px;
  margin: 0 auto;
  background: #fff;
  padding: 120px 0;
  box-sizing: border-box;
}

.section-wrap {
  width: 1554px;
  margin: 0 auto;
  text-align: center;
}

.section-header {
  margin-bottom: 80px;
}

.section-kicker {
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  margin-bottom: 12px;
  color: #6b7280;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.section-title {
  font-family: alibaba, 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
  font-weight: 1000;
  font-size: 80px;
  color: #111111;
  line-height: 80px;
  text-align: center;
  margin-bottom: 40px;
}

.section-desc {
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
  font-weight: 400;
  font-size: 20px;
  color: #111111;
  line-height: 32px;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.vision-text {
  font-size: 36px;
  font-weight: 700;
  color: #111111;
  line-height: 40px;
}

.service-grid {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-top: 60px;
}

.service-card {
  flex: 1;
  border-radius: 18px;
  padding: 32px;
  background: #f5f5f7;
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  text-align: left;
}

.service-card h3 {
  font-size: 22px;
  margin-bottom: 12px;
  color: #111111;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
  font-weight: 600;
}

.service-card p {
  font-size: 16px;
  line-height: 1.8;
  color: #4b5563;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.cases-grid {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  margin-top: 60px;
}

.cases-column {
  flex: 1;
  text-align: left;
}

.cases-column h3 {
  font-size: 20px;
  margin-bottom: 16px;
  color: #111111;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
  font-weight: 600;
}

.cases-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.cases-column li {
  font-size: 16px;
  line-height: 1.9;
  color: #4b5563;
  margin-bottom: 12px;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.contact-layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  margin-top: 60px;
  text-align: left;
}

.contact-block {
  flex: 1;
}

.contact-block h3 {
  font-size: 22px;
  margin-bottom: 16px;
  color: #111111;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
  font-weight: 600;
}

.contact-address {
  font-size: 16px;
  line-height: 1.9;
  color: #111111;
  margin-bottom: 20px;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.contact-note {
  font-size: 15px;
  line-height: 1.8;
  color: #6b7280;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.contact-item h4 {
  font-size: 18px;
  margin-bottom: 8px;
  color: #111111;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
  font-weight: 600;
}

.contact-item p {
  font-size: 16px;
  color: #4b5563;
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.site-footer {
  position: relative;
  width: 100%;
  min-width: 1280px;
  background: #111;
  padding: 40px 0;
}

.footer-inner {
  width: 100%;
  max-width: 1920px;
  min-width: 1280px;
  margin: 0 auto;
  padding: 0 32px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Tahoma, Arial, 'Hiragino Sans GB',
    'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', sans-serif;
}

.footer-inner a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
}

.footer-inner a:hover {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: underline;
}

@media (max-width: 1920px) {
  .content-section {
    width: 100%;
  }

  .section-wrap {
    width: 90%;
    max-width: 1554px;
  }
}

@media (max-width: 1200px) {
  .header-inner {
    padding: 16px 20px;
  }

  .main-nav {
    gap: 16px;
    font-size: 12px;
  }

  .nav-cta {
    padding: 6px 16px;
    font-size: 12px;
  }

  .brand-name-cn {
    font-size: 16px;
  }

  .hero-title {
    font-size: 48px;
  }

  .section-title {
    font-size: 56px;
  }

  .service-grid,
  .cases-grid,
  .contact-layout {
    flex-direction: column;
  }

  .contact-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 960px) {
  .header-inner {
    padding: 12px 16px;
  }

  .main-nav {
    gap: 12px;
    font-size: 11px;
  }

  .main-nav a {
    white-space: nowrap;
  }

  .nav-cta {
    padding: 6px 12px;
    font-size: 11px;
  }

  .brand-name-cn {
    font-size: 14px;
  }
}
</style>
